import { useQuery } from '@apollo/client/react';
import { isDefined } from 'app-shared/utils';
import { SKIP_ERROR_TOAST_CONTEXT } from '@/apollo/constants/SkipErrorToastContext';
import { GetInterventionTypesDocument } from '~/generated/graphql';
export const useInterventionTypes = () => {
  const { data, loading, error, refetch } = useQuery(
    GetInterventionTypesDocument,
    {
      context: SKIP_ERROR_TOAST_CONTEXT,
    },
  );
  return {
    interventionTypes: data?.interventionTypes ?? [],
    isLoading: loading && !isDefined(data),
    error,
    refetch,
  };
};
